<template>
  <v-dialog v-model="showDialog" max-width="500" persistent>
    <v-card>
      <v-card-title class="text-h5">
        {{ $t("common.action.exportPrices") }}
      </v-card-title>

      <v-card-text>
        <p>{{ $t("common.message.exportPricesWithFilters") }}</p>
        <CatalogExportFilterSummary empty-message-key="common.message.noActivePriceExportFilters" />

        <v-switch
          v-model="includeAdditionalPrices"
          color="primary"
          :label="$t('common.action.includeAdditionalPrices')"
          :hint="$t('common.action.includeAdditionalPricesHint')"
          persistent-hint
          hide-details="auto"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="grey" variant="text" :disabled="isLoading" @click="closeDialog">
          {{ $t("common.action.cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          variant="text"
          :loading="isLoading"
          :disabled="isLoading"
          @click="confirmExport"
        >
          {{ $t("common.action.exportPrices") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import type { PriceExportScope } from "@nectarpay/api-contracts";
import CatalogExportFilterSummary from "@/catalog/components/product/CatalogExportFilterSummary.vue";

const showDialog = ref(false);
const isLoading = ref(false);
const includeAdditionalPrices = ref(true);
const emit = defineEmits<{ confirm: [priceScope: PriceExportScope] }>();

const open = () => {
  includeAdditionalPrices.value = true;
  showDialog.value = true;
};

const closeDialog = () => {
  showDialog.value = false;
};

const confirmExport = () => {
  isLoading.value = true;
  emit("confirm", includeAdditionalPrices.value ? "all_active" : "defaults_only");
  setTimeout(() => {
    isLoading.value = false;
    closeDialog();
  }, 300);
};

defineExpose({ open, close: closeDialog });
</script>
